import { bindActionCreators } from "redux";
import { mainnet, testnet, devnet } from "../modules/appState";
import { connect } from "react-redux";

const URL = () => `${process.env.REACT_APP_API_URL}/api/anduschain`;
const URL_V2 = `${process.env.REACT_APP_API_V2_URL}/api`;
const WS_URL = () => `${process.env.REACT_APP_WSHOST}`;
const IP_ADDR = (ip) => `https://ipapi.co/${ip}/json/`;

const API = () => {
  return {
    recently: `${URL()}/recently`, // 최근 블록 및 tx 리턴 10개씩
    miners: `${URL()}/miners`, // 채굴 신청자 위치

    recentblocks: `${URL()}/recentblocks`, // 그래프용 최근 블록

    blocks: `${URL_V2}/block`,
    block: `${URL()}/block`, // path > /:number 로 호출하면, 블록 세부 내역 넘어옴
    lastBlock: `${URL_V2}/block/last`,

    transactions: `${URL()}/transactions`, // path > /:page 로 호출하면, 25개씩 리스트가 넘어옴
    transaction: `${URL_V2}/transaction`, // path > /:hash 로 호출하면, tx 세부 내역 넘어옴

    transactionList: `${URL_V2}/transaction/txList`, // path ->page 로 호출하면 25개 리스트

    transactionByAddress: `${URL_V2}/transaction/address`,
    transactionByBlock: `${URL_V2}/transaction/block`,
    transactionListByTokenType: `${URL_V2}/transaction/txList/tokenType`,
    account: `${URL()}/account`, // path > /:account 로 호출하면, 어카운트 내역 나옴

    isContract: `${URL_V2}/contract/exist`,
    searchContract: `${URL_V2}/contract/search`,
    contract: `${URL_V2}/contract`,
    contractList: `${URL_V2}/contract/contractList/search`,

    getTokenURI: `${URL_V2}/contract/tokenURI`,

    transfer: `${URL_V2}/transfer`,

    topRank: `${URL_V2}/balance/topRank`,
    totalBalance: `${URL_V2}/balance/totalBalance`,

    // topRank: `http://10.10.30.26:8082/api/balance/topRank`,
    // totalBalance: `http://10.10.30.26:8082/api/balance/totalBalance`,
  };
};

const mapStateToProps = (state) => {
  return {
    network: state.appState.network,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeMainnet: bindActionCreators(mainnet, dispatch),
  changeTestnet: bindActionCreators(testnet, dispatch),
  changeDevnet: bindActionCreators(devnet, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(API);

export { URL, WS_URL, API, IP_ADDR };
